//      
                                                                           

export default (impact            )               => {
  const at                  = impact.at;

  if (!at) {
    return null;
  }

  if (at.type === 'REORDER') {
    return at.destination.droppableId;
  }

  return at.combine.droppableId;
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/droppable/what-is-dragged-over.js